/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions" endpoint.
 * Returns the creative-variant dimensions available to this DSA: every dimension in
 * CreativeVariantDimensions::USER_FACING_ROLLOUT, with its input-shape type and active variant count.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensions,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/creative_variants/dimensions`,
      "GET",
      {},
      { signal }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsResult
);
